<template lang="html">
  <div class="messages-wrapper">
    <template v-if="!activeChat">
      <div v-if="chats.length">
        <div
          v-for="chat in chats"
          :key="chat.msg_id"
          class="notification"
          @click="activeChat = chat.usr_id"
        >
          <div class="notification-info">
            <div class="left">
              <div class="dot" v-if="chat.msg_read != 1"></div>
              <div class="ntf-text">{{ chat.usr_name }}</div>
            </div>
            <div class="right">
              <div class="ntf-date">
                {{ $moment(chat.msg_date).format("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        {{ $t("profile.notifications.note") }}
      </div>
    </template>
    <template v-else>
      <Chat :chat="activeChat" @closeChat="activeChat = null" />
    </template>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import Chat from "@/components/profile/chat.vue";
export default {
  name: "messages",
  components: {
    Chat
  },
  data() {
    return {
      chats: [],
      activeChat: null
    };
  },
  mounted() {
    this.getMessages();
    eventBus.$on("refreshMessages", this.getMessages);
  },
  methods: {
    getMessages() {
      api
        .getMessages()
        .then(res => {
          this.chats = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
      api.getNotificationsCount().then(res => {
        this.$store.commit("setNotificationCounters", res.data);
      });
    }
  },
  destroyed() {
    eventBus.$off("refreshMessages");
  }
};
</script>

<style lang="scss" scoped>
.messages-wrapper {
  // max-width: 800px;
  .notification {
    box-sizing: border-box;
    width: 100%;
    background: $gray-blue-400;
    border: 1px solid $gray-blue-700;
    border-radius: 15px;
    margin: 10px 0;
    padding: 5px 20px;

    .notification-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .left {
        width: 60%;
        display: flex;
        align-items: center;
        .dot {
          min-height: 10px;
          min-width: 10px;
          background-color: $light-blue-600;
          border-radius: 50%;
          display: inline-block;
          margin-right: 10px;
        }
        .ntf-text {
          max-height: 60px;
          overflow: hidden;
          line-height: 60px;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%;
          text-align: left;
        }
      }
      .right {
        width: 40%;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 5px;
        .ntf-date {
          color: $blue-400;
        }
        .icon {
          font-size: 30px;
          cursor: pointer;
          &.rotate {
            transition: transform 0.2s;
            transform: rotate(180deg);
          }
          &.red {
            color: $red-600;
            margin-left: 10px;
          }
        }
      }
    }
    .notification-text {
      transition: max-height 0.6s ease;
      overflow: hidden;
    }
  }
}
</style>
